var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKbvArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 1.358l2.835 2.977c.21.22.549.22.758 0a.583.583 0 000-.795L4.13.165a.518.518 0 00-.758 0L.157 3.54a.583.583 0 000 .795c.21.22.548.22.758 0L3.75 1.358z",
    fill: "#fff",
    transform: "translate(3.75 4.5)",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKbvArrowRight);
export default __webpack_public_path__ + "static/media/kbv-arrow-right.c4d78aea9ad3ededb806b85a6f1a3d23.svg";
export { ForwardRef as ReactComponent };